// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%236B7280%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model-customized-content {
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  overflow: visible;
}

/* 信息徽章区域 */
.model-info-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.badge-label,
.badge-samples {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  display: inline-block;
  transition: all 0.2s ease;
  text-align: center;
}

.badge-label {
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.badge-samples {
  background-color: #F3F4F6;
  color: #374151;
  border: 1px solid #E5E7EB;
}

/* 模型选择框包装器 */
.model-select-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 100;
}

.local-model-select {
  width: 100%;
  max-width: 100%;
  padding: 10px 12px;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  background-color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
  text-align: center;
}

.local-model-select:hover {
  border-color: #8B5CF6;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
}

.local-model-select:focus {
  outline: none;
  border-color: #8B5CF6;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.15);
}

.local-model-select option {
  padding: 8px;
  text-align: center;
}

/* 按钮组 */
.model-choice-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.model-choice-container .org-btn {
  width: 100%;
  min-height: 38px;
  font-size: 13px;
}

.model-button-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.model-button-group .org-btn {
  width: 100%;
  min-height: 38px;
  font-size: 13px;
}

.button-row {
  display: flex;
  gap: 1rem;
}

.loadModel {
  margin-bottom: 0.5rem;
}

.dag-select {
  width: 90%;
}

.model-info {
  width: 95%;
  margin-right: -2rem;
}

.model-info p {
  margin-bottom: 0.2rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.model-info p:hover {
  text-overflow: visible;
  white-space: normal;
}

.auto-dag {
  width: 600px;
  margin: 0 auto;
}

.auto-dag select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.local-model-select {
  width: 220px;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  margin: 0.5rem;
}

.model-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.model-page .datasets {
  width: 100%;
  margin: 0;
}

.model-customized-content {
  padding: 0;
  gap: 12px;
  align-items: stretch;
}

.model-info-badges {
  justify-content: flex-start;
}

.badge-label,
.badge-samples {
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}

.status-ready {
  border: 1px solid #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.status-empty {
  border: 1px solid #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.badge-samples {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
}

`, "",{"version":3,"sources":["webpack://./src/pages/PreLabelPage/PreLabelPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,yDAA0L;EAC1L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".model-customized-content {\n  width: 100%;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n  overflow: visible;\n}\n\n/* 信息徽章区域 */\n.model-info-badges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n}\n\n.badge-label,\n.badge-samples {\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  display: inline-block;\n  transition: all 0.2s ease;\n  text-align: center;\n}\n\n.badge-label {\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.badge-samples {\n  background-color: #F3F4F6;\n  color: #374151;\n  border: 1px solid #E5E7EB;\n}\n\n/* 模型选择框包装器 */\n.model-select-wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  z-index: 100;\n}\n\n.local-model-select {\n  width: 100%;\n  max-width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #E5E7EB;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #374151;\n  background-color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236B7280' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  padding-right: 36px;\n  text-align: center;\n}\n\n.local-model-select:hover {\n  border-color: #8B5CF6;\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);\n}\n\n.local-model-select:focus {\n  outline: none;\n  border-color: #8B5CF6;\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.15);\n}\n\n.local-model-select option {\n  padding: 8px;\n  text-align: center;\n}\n\n/* 按钮组 */\n.model-choice-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.model-choice-container .org-btn {\n  width: 100%;\n  min-height: 38px;\n  font-size: 13px;\n}\n\n.model-button-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.model-button-group .org-btn {\n  width: 100%;\n  min-height: 38px;\n  font-size: 13px;\n}\n\n.button-row {\n  display: flex;\n  gap: 1rem;\n}\n\n.loadModel {\n  margin-bottom: 0.5rem;\n}\n\n.dag-select {\n  width: 90%;\n}\n\n.model-info {\n  width: 95%;\n  margin-right: -2rem;\n}\n\n.model-info p {\n  margin-bottom: 0.2rem;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.model-info p:hover {\n  text-overflow: visible;\n  white-space: normal;\n}\n\n.auto-dag {\n  width: 600px;\n  margin: 0 auto;\n}\n\n.auto-dag select {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n}\n\n.local-model-select {\n  width: 220px;\n  padding: 8px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  margin: 0.5rem;\n}\n\n.model-page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.model-page .datasets {\n  width: 100%;\n  margin: 0;\n}\n\n.model-customized-content {\n  padding: 0;\n  gap: 12px;\n  align-items: stretch;\n}\n\n.model-info-badges {\n  justify-content: flex-start;\n}\n\n.badge-label,\n.badge-samples {\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.status-ready {\n  border: 1px solid #bbf7d0;\n  background: #f0fdf4;\n  color: #15803d;\n}\n\n.status-empty {\n  border: 1px solid #fecdd3;\n  background: #fff1f2;\n  color: #be123c;\n}\n\n.badge-samples {\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #475569;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
